<template lang="pug">
  div(v-click-outside="close")
    .common-modal(v-if="!completed" :class="{ open: sending }")
      a.common-modal-close(@click="close")
        | 閉じる
      .common-modal-title
        | 現在の条件を保存します
      .common-modal-main
        .common-modal-main-inner
          p
            ErrorMessage(:errors="errors" name="system")
          p
            label.radio
                input(type='radio' v-model="isNew" v-bind:value="true")
                span 新規
            br
            label.radio
              input(type='radio' v-model="isNew" v-bind:value="false" :disabled="savedList.length == 0")
              span 既存の条件に上書き保存
            br
            template(v-if="!isNew")
              select(v-model="updateId")
                option(v-for="option in savedList" :value="option.id") {{ option.name }}
          p
            input(type="text" v-model="name" placeholder="例）リクナビネクスト／出稿予算", :disabled="locked")
          p
            template(v-if="isNew")
              | 検索条件に名前をつけて保存できます。
              br
              | 最大50件、検索条件を保存することができます。
            template(v-else)
              | 検索条件の名前を変更できます。
          p.common-modal-button
            input.button-main(type="button", value="保存する" @click="saveSearchCondition")
    .common-modal(v-else :class="{ open: sending }")
      a.common-modal-close(@click="close")
        | 閉じる
      .common-modal-title
        | 市況分析管理に検索条件を追加しました
      .common-modal-main
        .common-modal-main-inner
          p
            | 選択されていた検索条件を市況分析管理に追加しました。
            br
            | 追加された検索条件は市況分析管理からご確認いただけます。
          p.common-modal-button
            router-link(:to="{ name: 'AggJobSearchConditions' }",
                        class="button-main" @click.native="close")
              |  市況分析管理を確認する
    .modal-cover(@click="close")

</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import ClickOutside from 'vue-click-outside'
  import ErrorMessage from './ErrorMessage'

  export default {
    directives: { ClickOutside },
    data () {
      return {
        name: '',
        completed: false,
        isNew: true,
        updateId: null,
      }
    },
    components: { ErrorMessage },
    mounted () {
      this.popupItem = this.$el
    },
    computed: {
      ...mapState({
        errors: state => state.aggJobSearchCondition.errors,
      }),
      ...mapGetters({
        locked: 'common/isGlobalLocked',
        sending: 'aggJobSearchCondition/sending',
        condition: 'aggJobSearchCondition/condition',
        savedList: 'aggJobSearchCondition/list',
      }),
    },
    watch: {
      $route () {
        this.$store.commit('aggJobSearchCondition/hideAggJobSearchConditionModal')
      },
      isNew (v) {
        if (v) {
          this.name = ''
        } else {
          const selectedCondition = this.savedList[0]
          this.updateId = selectedCondition.id
          this.name = selectedCondition.name
        }
      },
      updateId (id) {
        const searchCondition = this.savedList.find(s => s.id === id)
        this.name = searchCondition.name
      },
    },
    methods: {
      close () {
        this.$store.commit('aggJobSearchCondition/hideAggJobSearchConditionModal')
        this.$store.commit('aggJobSearchCondition/errors', [])
        this.completed = false
        this.name = ''
        this.isNew = true
      },
      async saveSearchCondition () {
        const name = this.name
        const condition = this.condition
        const id = this.isNew ? null : this.updateId

        this.$store.commit('common/lockGlobal')
        try {
          await this.$store.dispatch('aggJobSearchCondition/send', { id, name, condition })
          this.completed = true
          this.name = ''
        } finally {
          this.$store.commit('common/unlockGlobal')
        }
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/AggJobSearchConditionModal.vue